import type { Type_DisplayUnitUuid, Type_IDisplayUnit, Type_IUnit, Type_IUnitListItem } from '../Type/Type.hive'

export function Unit_toDisplayUnit(
    instanceId: Type_DisplayUnitUuid,
    unit: Type_IUnit,
    unitListItem: Type_IUnitListItem,
    unitListId: number
): Type_IDisplayUnit {
    if (!instanceId || !unit) throw new Error('InstanceId and unit are required arguments')
    return {
        instanceId,
        unit,
        unitListId,
        unitListItem,
        reportedIssues: [],
        forms: [],
        infoPills: [],
        processFlow: [
            {
                question: 1,
                answer: null,
            },
        ],
    }
}
